import {
  getAccessibilityRequests
} from "./chunk-G6JPNACT.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/accessibility/getAccessibilityRequests.ts
import { useQuery } from "@tanstack/react-query";
var useGetAccessibilityRequests = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["accessibilityRequests"],
    queryFn: () => getAccessibilityRequests(props)
  }, options));
};

export {
  useGetAccessibilityRequests
};
//# sourceMappingURL=chunk-YGCV3NRZ.mjs.map